import type { SearchCriteria } from '@/entities/searchCriteria';
import type { DateRange } from '@/shared/model';
import DefaultCriteriaState from './DefaultCriteriaState';
import type { AlternativeSearchContext, AlternativeSearchState, AlternativeSearchView } from './types';
import { withCheckInDate, withFlexibleDates } from '../../lib/alternativeSearchCriteria';
import { hasSerpProducts } from '../../lib/toSerpProducts';

function getSearchedDateRanges(userCriteria: SearchCriteria): DateRange[] {
  const dateRanges = [userCriteria.dateRange, withFlexibleDates(userCriteria)?.dateRange];

  return dateRanges.flatMap((dateRange) => (dateRange ? [dateRange] : []));
}

export default class CalendarMinPriceState implements AlternativeSearchState {
  readonly criteria: SearchCriteria | null;

  private readonly unsubscribe: () => void;

  constructor(private readonly context: AlternativeSearchContext) {
    const { userCriteria } = context;
    const date = context.getCalendarMinPriceDate(getSearchedDateRanges(userCriteria));

    this.criteria = date ? withCheckInDate(userCriteria, date) : null;

    this.unsubscribe = context.productSearch.on('end', (result) => {
      if (result.state !== 'finished' || hasSerpProducts(result)) return;

      context.setState(new DefaultCriteriaState(context));
    });
  }

  get view(): AlternativeSearchView | null {
    return this.criteria ? { kind: 'similar', criteria: this.criteria } : null;
  }

  start(): void {
    const { criteria, context } = this;

    if (!criteria) {
      context.setState(new DefaultCriteriaState(context));
      return;
    }

    context.productSearch.run(criteria, { mode: 'sync' });
  }

  dispose(): void {
    this.unsubscribe();
  }
}
